<template>
    <div class="form-group" :class="{ 'has-error': errorMessage }">
        <label v-if="label" class="control-label">{{ label }}</label>
        <select
            v-if="canSwitchAccount"
            :id="inputId"
            v-model="selectedAccountId"
            class="form-control"
            name="account_id"
            :disabled="disabled"
            @change="emitChange"
        >
            <option v-for="account in accounts" :key="account.id" :value="account.id">
                {{ account.label }}
            </option>
        </select>
        <input
            v-else
            type="hidden"
            name="account_id"
            :value="selectedAccountId"
        >
        <p v-if="errorMessage" class="help-block">{{ errorMessage }}</p>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Number,
            required: true,
        },
        canSwitchAccount: {
            type: Boolean,
            default: false,
        },
        accountsUrl: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: '',
        },
        inputId: {
            type: String,
            default: 'tenant-account-select',
        },
    },
    emits: ['update:modelValue'],
    data() {
        return {
            accounts: [],
            selectedAccountId: this.modelValue,
        };
    },
    async mounted() {
        if (this.canSwitchAccount && this.accountsUrl) {
            const response = await fetch(this.accountsUrl, {
                headers: { Accept: 'application/json' },
            });

            if (response.ok) {
                const payload = await response.json();
                this.accounts = payload.accounts || [];
            }
        }

        if (! this.canSwitchAccount || this.accounts.length === 0) {
            this.accounts = [{ id: this.modelValue, label: String(this.modelValue) }];
        }

        if (! this.accounts.some((account) => account.id === this.selectedAccountId)) {
            this.selectedAccountId = this.accounts[0]?.id ?? this.modelValue;
            this.emitChange();
        }
    },
    methods: {
        emitChange() {
            this.$emit('update:modelValue', Number(this.selectedAccountId));
        },
    },
};
</script>
